import React, { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import { RiskBadge, PriorityBadge, Avatar } from "../components/Badges";
import { ShieldAlert, Lightbulb } from "lucide-react";

export default function Risks() {
  const [risks, setRisks] = useState([]);
  useEffect(() => { api.get("/risks").then((r) => setRisks(r.data)); }, []);

  const counts = { alto: 0, medio: 0, bajo: 0 };
  risks.forEach((r) => (counts[r.risk_level] += 1));

  return (
    <div>
      <div className="bg-white border-b border-border px-8 py-6">
        <p className="text-[11px] uppercase tracking-[0.2em] text-slate-400">Análisis</p>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight mt-0.5 flex items-center gap-2"><ShieldAlert className="h-7 w-7" />Gestión de Riesgos</h1>
      </div>

      <div className="grid grid-cols-3 border-t border-l border-border">
        {[
          { l: "Riesgo Alto", v: counts.alto, c: "#DC2626" },
          { l: "Riesgo Medio", v: counts.medio, c: "#D97706" },
          { l: "Riesgo Bajo", v: counts.bajo, c: "#16A34A" },
        ].map((s) => (
          <div key={s.l} className="border-r border-b border-border bg-white p-5">
            <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">{s.l}</span>
            <div className="font-heading text-4xl font-extrabold tracking-tighter mt-2" style={{ color: s.c }}>{s.v}</div>
          </div>
        ))}
      </div>

      <div className="p-8 space-y-3">
        {risks.map((r) => (
          <div key={r.id} data-testid={`risk-${r.dev_id}`} className="border border-border bg-white rounded-sm p-5 flex items-start gap-4">
            <div className="shrink-0"><RiskBadge level={r.risk_level} /></div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="font-mono text-xs text-slate-400">{r.dev_id}</span>
                <span className="font-semibold">{r.title}</span>
                <PriorityBadge priority={r.priority} />
              </div>
              <div className="flex flex-wrap gap-1.5 mt-2">
                {r.risk_reasons.map((reason, i) => (
                  <span key={`${reason}-${i}`} className="text-[11px] bg-slate-100 border border-slate-200 rounded-sm px-2 py-0.5 text-slate-600">{reason}</span>
                ))}
              </div>
              <div className="flex items-start gap-1.5 mt-3 text-sm text-slate-600 bg-amber-50 border border-amber-200 rounded-sm px-3 py-2">
                <Lightbulb className="h-4 w-4 text-amber-600 shrink-0 mt-0.5" />
                <span><strong>Mitigación sugerida:</strong> {r.mitigation}</span>
              </div>
            </div>
            {r.responsable && <div className="shrink-0 flex flex-col items-center gap-1"><Avatar user={r.responsable} size={32} /><span className="text-[10px] text-slate-400">{r.responsable.name.split(" ")[0]}</span></div>}
          </div>
        ))}
        {risks.length === 0 && <p className="text-slate-400">No se detectaron riesgos activos.</p>}
      </div>
    </div>
  );
}
